import 'moment/locale/pt-br';
import { Outlet } from 'react-router-dom';

import AppProvider from '../app/AppProvider';
import AppLoading from '../components/AppLoading';

function RootNavigator() {
  return (
    <AppProvider>
      <AppLoading>
        <Outlet />
      </AppLoading>
    </AppProvider>
  );
}

export default RootNavigator;
